import React, { Component } from 'react';
import Main from './Main';

export default class CheckMain extends Component {
  render() {
    const { ...rest } = this.props;
    return (
      <div>
        <Main {...rest} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Building/Main/index.js